module.exports = __webpack_public_path__ + "img/Icon-12.defa0a4f.png";